import {useEffect, useRef, useState} from 'react';
import {MENU_SOUND_MANAGER} from '../../scenes/MenuSoundManager';

export function canPlayFactionSound(factionId, lastPlayedByFactionRef) {
  if (!factionId || !lastPlayedByFactionRef) return true;
  const lastPlayed = lastPlayedByFactionRef.current[factionId];
  if (!lastPlayed) return true;
  return Date.now() - lastPlayed > 5000;
}

export function playFactionSound(factionId, lastPlayedByFactionRef, noIntro) {
  if (lastPlayedByFactionRef && !canPlayFactionSound(factionId, lastPlayedByFactionRef)) {
    MENU_SOUND_MANAGER.playFactionSelectIntro();
    return true;
  }
  MENU_SOUND_MANAGER.playFactionSelect(factionId, noIntro);
  if (lastPlayedByFactionRef) {
    lastPlayedByFactionRef.current[factionId] = Date.now();
  }
  return true;
}

export function useFactionHoverSound(factionId, lastPlayedByFactionRef) {
  const [isHovered, setIsHovered] = useState(false);
  const [isLongHovered, setIsLongHovered] = useState(false);
  const timerRef = useRef(null);

  const onMouseEnter = () => {
    setIsHovered(true);
    timerRef.current = setTimeout(() => {
      setIsLongHovered(true);
      if (canPlayFactionSound(factionId, lastPlayedByFactionRef)) {
        playFactionSound(factionId, lastPlayedByFactionRef, true);
      }
    }, 1500);
  };

  const onMouseLeave = () => {
    setIsHovered(false);
    setIsLongHovered(false);
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  return {isHovered, isLongHovered, onMouseEnter, onMouseLeave};
}
